import React from "react";

function Categories({ onSelectCategory, content }) {
  const categories = content?.cards || [];

  return (
    <section id="categories" className="categories-section">
      <div className="section-wrap">
        <div className="section-eyebrow">{content?.eyebrow}</div>
        <h2 className="section-title">{content?.title}</h2>
        <p className="section-sub">{content?.subtitle}</p>
        <div className="cat-grid">
          {categories.map((category) => (
            <button
              type="button"
              className="cat-card"
              key={category.name}
              onClick={() => onSelectCategory(category.targetCategory || category.name)}
            >
              <div className="cat-icon" aria-hidden="true">
                {category.icon}
              </div>
              <div className="cat-name">{category.name}</div>
              <div className="cat-sub">{category.subTypes}</div>
              <div className="cat-tech">{category.technology}</div>
              <div className="cat-bar-wrap">
                <div className="cat-bar">
                  <div className="cat-bar-inner" style={{ width: category.width }}></div>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Categories;
